import { createElement, useContext, createContext } from 'react';
import cn from 'classnames';
import { RadioGroup as RadioGroup$1, RadioItem as RadioItem$1, ItemIndicator } from '@radix-ui/react-dropdown-menu';
import { useItemStyling } from './Item.js';
import { useRadioGroup, getRadioGroupItemValueAsString } from '../../RadioGroup/RadioGroup.js';

const RadioItem = props => {
  const context = useContext(MenuRadioGroupContext);
  const {
    children,
    value,
    ...otherProps
  } = props;
  const disabled = context.disabled || props.disabled;
  const className = useItemStyling({
    disabled: disabled,
    indented: true,
    className: props.className
  });
  return createElement(RadioItem$1, Object.assign({}, otherProps, {
    className: className,
    disabled: disabled,
    value: getRadioGroupItemValueAsString(value)
  }), createElement(ItemIndicator, {
    className: "absolute left-0 ml-1.5"
  }, createElement("span", {
    className: "ml-1 flex h-1.5 w-1.5 rounded-full bg-current "
  })), children);
};
const MenuRadioGroupContext = /*#__PURE__*/createContext({
  disabled: false
});
const RadioGroup = props => {
  const {
    context,
    props: otherProps
  } = useRadioGroup(props);
  const className = cn('flex flex-col', props.className);
  return createElement(MenuRadioGroupContext.Provider, {
    value: context
  }, createElement(RadioGroup$1, Object.assign({}, otherProps, {
    className: className
  })));
};
RadioGroup.Item = RadioItem;

export { RadioGroup, RadioItem };
//# sourceMappingURL=RadioGroup.js.map
